"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ILULeadsDashboardState;
(function (ILULeadsDashboardState) {
    ILULeadsDashboardState[ILULeadsDashboardState["empty"] = 0] = "empty";
    ILULeadsDashboardState[ILULeadsDashboardState["loading"] = 1] = "loading";
    ILULeadsDashboardState[ILULeadsDashboardState["normal"] = 2] = "normal";
})(ILULeadsDashboardState = exports.ILULeadsDashboardState || (exports.ILULeadsDashboardState = {}));
